<script lang="ts">
  // Libs
  import { onMount } from "svelte";

  // Stores
  import layoutStore from "@shared/svelte/Stores/LayoutStore";
  import FuturePricesStore from "@shared/svelte/Stores/FuturePricesStore";

  // Components
  import SubmitBox from "@retailer/svelte/Cart/Page/SubmitBox.svelte";
  import SavedForLaterSection from "@retailer/svelte/Cart/SavedForLater/Section.svelte";
  import DistributorSection from "@retailer/svelte/Cart/Page/DistributorSection/DistributorSection.svelte";
  import OrderReviewSection from "@retailer/svelte/Cart/Page/OrderReviewSection.svelte";

  // Types
  import type { CartType } from "@shared/types/Cart";
  import type { SavedProductDict } from "@shared/types/SavedProducts";

  import { loadFuturePrices } from "@retailer/services/future_prices_service";

  // Props
  export let managers;
  export let cartService;
  export let cart: CartType;
  export let showLoading: boolean;
  export let highlightErrors: boolean;
  export let callbacks;
  export let savedProducts: SavedProductDict;
  export let openConnectDistributorModal;

  // Data
  let customPricingMode = {};
  let managersForSubmit = {};
  let showSaveForLater: boolean;
  let accordionOpenByDefault: boolean = cart?.orders?.length == 1;
  let futurePricesLoading: boolean = true;

  const orderReviewContainerClasses =
    "fizz-flex-item fizz-stack-16 fizz-surface fizz-inset-square-24 fizz-radius-medium";

  // Functions
  const highlightErrorsOnSubmit = () => {
    highlightErrors = true;
  };

  // Lifecycle
  onMount(() => {
    loadFuturePrices(FuturePricesStore, cart.orders).then(() => (futurePricesLoading = false));
  });

  $: {
    if (!cart) showSaveForLater = false;
    else if (!savedProducts) showSaveForLater = false;
    else showSaveForLater = Object.entries(savedProducts).length > 0;
  }
</script>

<div class="fizz-surface-gray" class:fizz-inset-vertical-12={$layoutStore.isDesktop}>
  <div
    class="fizz-container fizz-align-content-start"
    class:fizz-flex-vertical={$layoutStore.isMobile}
    class:fizz-flex-row={$layoutStore.isDesktop}
    class:fizz-inset-squish-32={$layoutStore.isDesktop}
    class:fizz-flex-row-24={$layoutStore.isDesktop}
  >
    {#if $layoutStore.isMobile}
      <div
        data-testid="mobile-submit-box"
        class="fizz-flex-vertical fizz-full-width fizz-sticky-top fizz-elevation-1"
      >
        <div class="fizz-flex-item">
          <SubmitBox
            Cart={cartService}
            {cart}
            {managers}
            {managersForSubmit}
            on:submitWithErrors={highlightErrorsOnSubmit}
            bind:showLoading
          />
        </div>
      </div>
    {/if}

    <div class="fizz-flex-vertical fizz-full-width">
      {#if cart && cart.orders}
        {#each cart.orders as order, dindex (order.id)}
          {#if order}
            <div
              class="fizz-stack-16"
              class:expose={customPricingMode[order.distributor.id]}
              data-order-id={order.id}
            >
              <DistributorSection
                {callbacks}
                {cartService}
                {openConnectDistributorModal}
                {order}
                {futurePricesLoading}
                bind:showLoading
                isMobile={$layoutStore.isMobile}
                bind:customPricingMode
                accordionOpenByDefault={dindex === 0 ? accordionOpenByDefault : false}
                on:submitWithErrors={highlightErrorsOnSubmit}
                {highlightErrors}
              />
            </div>
          {/if}
        {/each}
      {/if}
    </div>
    {#if $layoutStore.isDesktop}
      <div
        data-testid="desktop-submit-box"
        class="fizz-flex-vertical fizz-half-width fizz-sticky-top"
        style="top: 20px; background-color: #F5F7F7;"
      >
        <OrderReviewSection
          {managers}
          {managersForSubmit}
          {cart}
          containerClasses={orderReviewContainerClasses}
        />
        <div class="fizz-flex-item">
          <SubmitBox
            Cart={cartService}
            {cart}
            {managers}
            {managersForSubmit}
            on:submitWithErrors={highlightErrorsOnSubmit}
            bind:showLoading
          />
        </div>
      </div>
    {/if}
  </div>
</div>
{#if showSaveForLater}
  <SavedForLaterSection
    {cartService}
    {callbacks}
    {savedProducts}
    isMobile={$layoutStore.isMobile}
    bind:showLoading
  />
{/if}
